import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import Shimmer from "react-shimmer-effect";
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'

class CreateView extends Component {

    indexBloc = new IndexBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detail: null
        }
    }

    loadDetail = async () => {
        this.indexBloc.fetchDetail({ uuid: this.props.uuid })
    }

    componentDidMount() {
        this.loadDetail()
        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                default:
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/pengecualian_penghargaan.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>                           
                            <CardTitle>Tambah Pengecualian Penghargaan</CardTitle>
                            <CardSubtitle className="mb-3">
                                Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                            </CardSubtitle>
                            <hr />

                            { this.state.detail == null ? 
                                <Shimmer>
                                    <div style={{ width: "100%", height: 40 }}></div>
                                </Shimmer>                            
                                :
                                <Fragment>
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="rank_name"
                                            className="col-md-2 col-form-label"
                                        >
                                        Nama Pegawai
                                        </label>
                                        <label
                                            htmlFor="rank_name"
                                            className="col-md-3 col-form-label"
                                        >
                                            {this.state.detail?.award_exception_employee_name}
                                        </label>
                                    </Row>
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="rank_name"
                                            className="col-md-2 col-form-label"
                                        >
                                        Nama Penghargaan
                                        </label>
                                        <label
                                            htmlFor="rank_name"
                                            className="col-md-3 col-form-label"
                                        >
                                            {this.state.detail?.award_exception_award_type_name}
                                        </label>
                                    </Row>
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="rank_name"
                                            className="col-md-2 col-form-label"
                                        >
                                        Alasan
                                        </label>
                                        <label
                                            htmlFor="rank_name"
                                            className="col-md-3 col-form-label"
                                        >
                                            {this.state.detail?.award_exception_note}
                                        </label>
                                    </Row>
                                </Fragment>
                            }
                        </CardBody>   
                    </Card>
                </Container>
            </Fragment>
        )
    }
}

export default CreateView